"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var ColumnHeaderCell_1 = require("../ColumnHeaderCell/ColumnHeaderCell");
var monitoring_1 = require("../../services/monitoring");
var classNames = require("classnames");
var Table = /** @class */ (function (_super) {
    __extends(Table, _super);
    function Table(props) {
        var _this = _super.call(this, props) || this;
        _this.endHoverDelay = null;
        _this.tableRefCallback = function (div) {
            _this.setState({
                tableRef: div
            });
        };
        _this.rowHovered = function (rowIndex) {
            clearTimeout(_this.endHoverDelay);
            if (rowIndex !== _this.state.hoverRowIndex) {
                _this.setState({ hoverRowIndex: rowIndex });
            }
        };
        _this.tableEndedHover = function (rowIndex) {
            clearTimeout(_this.endHoverDelay);
            _this.endHoverDelay = window.setTimeout(function () {
                this.setState({ hoverRowIndex: null });
            }.bind(_this), 100);
        };
        _this.state = { tableRef: null, hoverRowIndex: null };
        return _this;
    }
    Table.prototype.componentDidMount = function () {
        monitoring_1.default('table');
    };
    Table.prototype.findTableCell = function (element, rowIndex) {
        var cellTemplate = element.props.cell
            ? element.props.cell
            : Array.isArray(element.props.children)
                ? element.props.children[0]
                : element.props.children;
        if (!cellTemplate) {
            cellTemplate = element.props.renderCell(rowIndex);
        }
        return cellTemplate;
    };
    Table.prototype.findTableHeaderTemplate = function (element, columnIndex) {
        var headerTemplate = element.props.header ? (element.props.header) : (React.createElement(ColumnHeaderCell_1.default, { key: columnIndex + '_placeholder-header' }));
        if (!headerTemplate) {
            headerTemplate = element.props.renderHeader(columnIndex);
        }
        return headerTemplate;
    };
    Table.prototype.render = function () {
        var _this = this;
        var _a = this.props, displayData = _a.displayData, tableCellStyles = _a.tableCellStyles, disableHover = _a.disableHover, className = _a.className, style = _a.style;
        var hoverRowIndex = this.state.hoverRowIndex;
        var tableComponents = {};
        var classes = classNames('table--flex', className);
        // Create array of <Column> objects
        var columnObjects = React.Children.toArray(this.props.children);
        // Loop through columns
        columnObjects.forEach(function (ColumnObj, columnIndex) {
            tableComponents[columnIndex] = [];
            // Get the header from props or supply a placeholder <ColumnHeaderCell/> for spacing uniformity
            var headerTemplate = _this.findTableHeaderTemplate(ColumnObj, columnIndex);
            // Merge any global cell styles with the styles supplied to the <ColumnHeaderCell>
            var headerCellStyles = tableCellStyles
                ? __assign({}, tableCellStyles, headerTemplate.props.style) : headerTemplate.props.style;
            // Create the <ColumnHeaderCell/> instance and supply it with the displayData and cell styles
            var headerCell = React.cloneElement(headerTemplate, {
                style: headerCellStyles
            });
            tableComponents[columnIndex].push(headerCell);
            // Ensure data is supplied
            if (displayData) {
                // For every item in displayData, create a row cell
                displayData.forEach(function (element, rowIndex) {
                    // Find the cell template from props, otherwise try to use the first child
                    var cellTemplate = _this.findTableCell(ColumnObj, rowIndex);
                    // Merge any global cell styles with the styles supplied to the <Cell>
                    var cellStyles = tableCellStyles
                        ? __assign({}, tableCellStyles, cellTemplate.props.style) : cellTemplate.props.style || {};
                    if (rowIndex === hoverRowIndex) {
                        cellStyles.backgroundColor = '#e8e9ea';
                    }
                    // Prepare new <Cell/> props with the displayData, styles, and column / row indexes
                    var newCellProps = __assign({}, element, cellTemplate.props, { 
                        // Add merged styles from cellTemplate and globalTableCellStyles
                        style: cellStyles, 
                        // Provide cell indexes
                        columnIndex: columnIndex,
                        rowIndex: rowIndex, hovered: rowIndex === hoverRowIndex ? true : false });
                    // If hover is not disabled, add hover listener and hovered bool
                    if (!disableHover) {
                        newCellProps.onMouseOver = function () { return _this.rowHovered(rowIndex); };
                        newCellProps.hovered = rowIndex === hoverRowIndex ? true : false;
                    }
                    // Create the <Cell/> instance with the new props
                    var newCell = React.cloneElement(cellTemplate, newCellProps);
                    // Push the new <Cell/> into it's column array
                    tableComponents[columnIndex].push(newCell);
                });
            }
        });
        // Generate the final tree structure
        // by creating an instance of each <Column/> with an array of children <Cell/>s supplied as props
        var allComponents = Object.keys(tableComponents).map(function (key) {
            var CurrentColumn = React.cloneElement(columnObjects[key], { children: tableComponents[key] });
            return CurrentColumn;
        });
        return (React.createElement("div", { className: classes, style: style, onMouseOut: this.tableEndedHover }, allComponents));
    };
    return Table;
}(React.Component));
exports.default = Table;
//# sourceMappingURL=Table.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/callahan-react/es/components/Table/Table.js
// module id = 105
// module chunks = 0